<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="applyIndex" :areaShow="areaShow" :loginShow="loginShow"  :get-party-id="getPartyId" :reload-page="reloadPage"></headers>


          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" style="color:#888888" @click="urlTo('home')">首页</a> /<a href="javascript:void(0)" style="color:#888888" @click="urlTo('applyIndex')"> 个人办事</a> / <a href="javascript:void(0)" @click="urlTo('organinfoList',{yyType:yyType,title:title})"  style="color:#888888">{{title}}</a> / <span>{{title}}填报</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>

        <div class="wraper">
          <div class="advice" >
            <h2 class="tit8 line_bottom"><span><img src="../../../static/images/guide_sign8.png">{{itemDataYy.organTypeName}}填报</span><em><img src="../../../static/images/required.png">为必填项</em></h2>
               <!-- 报丧-->
              <el-form  v-if="yyType=='funeral'" style="padding-top: 50px" :rules="rules" :model="business" label-width="150px" ref="ruleForm" class="demo-ruleForm">
                <el-row >
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                    <el-form-item  label="预约单位：" prop="organName">
                      <el-input :disabled="true" v-model="business.organName"    style="width: 250px;"></el-input>

                    </el-form-item>
                  </div>
                  </el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                    <el-form-item  label="预约日期：" prop="yy_date">
                      <template >
                        <div class="block">
                          <el-date-picker
                            :picker-options="pickerOptions"
                            style="width: 250px"
                            value-format="yyyy-MM-dd"
                            v-model="business.yy_date"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </div>
                      </template>
                    </el-form-item>
                  </div>
                  </el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                    <el-form-item   label="车辆信息：" prop="car_id" >
                      <el-select
                        v-model="val"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in carList"
                          :key="item.carId"
                          :label="item.carName"
                          :value="item.carId" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  </el-col>

                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                    <el-form-item   label="时间信息：" prop="time_id" >
                      <el-select
                        v-model="business.time_id"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in timeList"
                          :key="item.timeId"
                          :label="item.startTime"
                          :value="item.timeId" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  </el-col>

                </el-row>

                <h2 class="information_tit">逝者信息</h2>
                <el-row>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="所在区划：" prop="selectedRegion">
                      <el-cascader   v-model="selectedRegion" :props="props" @change="onSelectedRegion"  :show-all-levels="false" clearable placeholder="请选择所在区划" style="width: 250px;"></el-cascader>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item label="接运地址：" prop="address">
                      <el-input v-model="business.address"  maxlength="11" placeholder="请输入"  style="width: 250px;"></el-input>
                    </el-form-item>
                  </div></el-col>
                </el-row>

                <el-row>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item label="逝者姓名：" prop="name">
                      <el-input v-model="business.name"  maxlength="11" placeholder="请输入"  style="width: 250px;"></el-input>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item label="证件类型：" prop="card_type">
                      <el-select
                        v-model="business.card_type"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in dictArr['document_type']"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div></el-col>
                </el-row>
                <el-row>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item   label="逝者证件号码：" prop="id_card">
                      <el-input v-model="business.id_card"   maxlength="18"   placeholder="请输入"  style="width: 250px;"></el-input>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="去世时间：" prop="death_date">
                      <template >
                        <div class="block">
                          <el-date-picker
                            :picker-options="pickerOptions2"
                            style="width: 250px"
                            value-format="yyyy-MM-dd"
                            v-model="business.death_date"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </div>
                      </template>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="死亡原因：" prop="death_cause">
                      <el-select
                        v-model="business.death_cause"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in dictArr['dead_resume']"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div></el-col>

                </el-row>
                <h2 class="information_tit">家属信息</h2>
                <el-row>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="家属姓名：" prop="req_name">
                      <el-input v-model="business.req_name"  maxlength="11" placeholder="请输入"  style="width: 250px;"></el-input>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="证件类型：" prop="req_card_type">
                      <el-select
                        v-model="business.req_card_type"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in dictArr['document_type']"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="家属证件号码：" prop="req_id_card">
                      <el-input v-model="business.req_id_card"   placeholder="请输入"  style="width: 250px;"></el-input>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="联系电话：" prop="mobile_phone">
                      <el-input v-model="business.mobile_phone"  maxlength="11" placeholder="请输入"  style="width: 250px;"></el-input>

                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="与逝者关系：" prop="relation">
                      <el-select
                        v-model="business.relation"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in dictArr['dead_relation']"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div></el-col>
                </el-row>
              </el-form>
              <!--  火化-->
              <el-form  v-if="yyType=='emplace'" style="padding-top: 50px" :rules="rules" :model="business" label-width="150px" ref="ruleForm" class="demo-ruleForm">
                <el-row >
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                    <el-form-item  label="预约单位：" prop="organName">
                      <el-input :disabled="true" v-model="business.organName"    style="width: 250px;"></el-input>
                    </el-form-item>
                  </div>
                  </el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                    <el-form-item  label="预约日期：" prop="yy_date">
                      <template >
                        <div class="block">
                          <el-date-picker
                            :picker-options="pickerOptions"
                            style="width: 250px"
                            value-format="yyyy-MM-dd"
                            v-model="business.yy_date"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </div>
                      </template>
                    </el-form-item>
                  </div>
                  </el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                    <el-form-item   label="寄存格位：" prop="resource_id" >
                      <el-cascader v-model="business.resource_id" :props="resources" :show-all-levels="false"    placeholder="请选择寄存格位" clearable style="width: 250px;"></el-cascader>
                    </el-form-item>
                  </div>
                  </el-col>


                </el-row>

                <h2 class="information_tit">逝者信息</h2>
                <el-row>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="所在区划：" prop="selectedRegion">
                      <el-cascader   v-model="selectedRegion" :props="props" @change="onSelectedRegion"  :show-all-levels="false" clearable placeholder="请选择所在区划" style="width: 250px;"></el-cascader>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item label="接运地址：" prop="address">
                      <el-input v-model="business.address"  maxlength="11" placeholder="请输入"  style="width: 250px;"></el-input>
                    </el-form-item>
                  </div></el-col>
                </el-row>

                <el-row>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item label="逝者姓名：" prop="name">
                      <el-input v-model="business.name"  maxlength="11" placeholder="请输入"  style="width: 250px;"></el-input>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item label="证件类型：" prop="card_type">
                      <el-select
                        v-model="business.card_type"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in dictArr['document_type']"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div></el-col>
                </el-row>
                <el-row>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item   label="逝者证件号码：" prop="id_card">
                      <el-input v-model="business.id_card"   maxlength="18"   placeholder="请输入"  style="width: 250px;"></el-input>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="火化时间：" prop="cremation_time">
                      <template >
                        <div class="block">
                          <el-date-picker
                            :picker-options="pickerOptions2"
                            style="width: 250px"
                            value-format="yyyy-MM-dd"
                            v-model="business.cremation_time"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </div>
                      </template>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="火化地点：" prop="cremation_place">
                      <el-input v-model="business.cremation_place"   placeholder="请输入"  style="width: 250px;"></el-input>
                    </el-form-item>
                  </div></el-col>

                </el-row>
                <h2 class="information_tit">家属信息</h2>
                <el-row>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="家属姓名：" prop="req_name">
                      <el-input v-model="business.req_name"  maxlength="11" placeholder="请输入"  style="width: 250px;"></el-input>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="证件类型：" prop="req_card_type">
                      <el-select
                        v-model="business.req_card_type"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in dictArr['document_type']"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="家属证件号码：" prop="req_id_card">
                      <el-input v-model="business.req_id_card"   placeholder="请输入"  style="width: 250px;"></el-input>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="联系电话：" prop="mobile_phone">
                      <el-input v-model="business.mobile_phone"  maxlength="11" placeholder="请输入"  style="width: 250px;"></el-input>

                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="与逝者关系：" prop="relation">
                      <el-select
                        v-model="business.relation"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in dictArr['dead_relation']"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div></el-col>
                </el-row>
              </el-form>
              <!--  墓位-->
              <el-form  v-if="yyType=='ceme'" style="padding-top: 50px" :rules="rules" :model="business" label-width="150px" ref="ruleForm" class="demo-ruleForm">
                <el-row >
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                    <el-form-item  label="预约单位：" prop="organName">
                      <el-input :disabled="true" v-model="business.organName"    style="width: 250px;"></el-input>

                    </el-form-item>
                  </div>
                  </el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                    <el-form-item  label="预约日期：" prop="yy_date">
                      <template >
                        <div class="block">
                          <el-date-picker
                            :picker-options="pickerOptions"
                            style="width: 250px"
                            value-format="yyyy-MM-dd"
                            v-model="business.yy_date"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </div>
                      </template>
                    </el-form-item>
                  </div>
                  </el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                    <el-form-item   label="墓位：" prop="resource_id" >
                      <el-cascader v-model="business.resource_id" :props="resources" :show-all-levels="false"    placeholder="请选择常住户口" clearable style="width: 250px;"></el-cascader>
                    </el-form-item>
                  </div>
                  </el-col>



                </el-row>

                <h2 class="information_tit">逝者信息</h2>

                <el-row>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item label="逝者姓名：" prop="name">
                      <el-input v-model="business.name"  maxlength="11" placeholder="请输入"  style="width: 250px;"></el-input>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item label="证件类型：" prop="card_type">
                      <el-select
                        v-model="business.card_type"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in dictArr['document_type']"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div></el-col>
                </el-row>
                <el-row>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item   label="逝者证件号码：" prop="id_card">
                      <el-input v-model="business.id_card"   maxlength="18"   placeholder="请输入"  style="width: 250px;"></el-input>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item   label="逝者证件号码：" prop="id_card">
                      <el-input v-model="business.id_card"   maxlength="18"   placeholder="请输入"  style="width: 250px;"></el-input>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="火化时间：" prop="cremation_time">
                      <template >
                        <div class="block">
                          <el-date-picker
                            :picker-options="pickerOptions2"
                            style="width: 250px"
                            value-format="yyyy-MM-dd"
                            v-model="business.cremation_time"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </div>
                      </template>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="火化地点：" prop="cremation_place">
                      <el-input v-model="business.cremation_place"   placeholder="请输入"  style="width: 250px;"></el-input>
                    </el-form-item>
                  </div></el-col>

                </el-row>



                <h2 class="information_tit">家属信息</h2>
                <el-row>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="家属姓名：" prop="req_name">
                      <el-input v-model="business.req_name"  maxlength="11" placeholder="请输入"  style="width: 250px;"></el-input>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="证件类型：" prop="req_card_type">
                      <el-select
                        v-model="business.req_card_type"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in dictArr['document_type']"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="家属证件号码：" prop="req_id_card">
                      <el-input v-model="business.req_id_card"   placeholder="请输入"  style="width: 250px;"></el-input>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="联系电话：" prop="mobile_phone">
                      <el-input v-model="business.mobile_phone"  maxlength="11" placeholder="请输入"  style="width: 250px;"></el-input>

                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="与逝者关系：" prop="relation">
                      <el-select
                        v-model="business.relation"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in dictArr['dead_relation']"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div></el-col>
                </el-row>
              </el-form>
              <div style="text-align: center">
                <el-button :loading="loading" type="primary" @click="submit" style=" width: 250px;
                         margin-left: 100px;" :disabled="disableds">提   交</el-button>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div style="line-height: 35px;">
      <el-dialog :close-on-click-modal ="false"  :before-close="handleDialogClose" :visible.sync="showClause" width="600px" >
        <div style="text-align: center;font-size: 18px;margin-top: -30px;">业务办理须知</div>
        <!--报丧-->
        <div v-if="yyType=='funeral'" style="font-size: 14px;margin-left: 40px;margin-right: 35px;">
          1、预约规则<br/>
          1.1 在本平台，用户可以对青海省殡葬单位的报丧业务进行预约。<br/>
          1.2 用户输入预约单位、预约时间、接运车辆、接运地址、逝者名称、去世时间等逝者信息，并输入预约人的姓名、电话、证件类型和证件号等预约人信息进行预约。<br/>
          2、办丧程序<br/>
          2.1 领取《居民死亡医学证明（推断）书》。在医院死亡的，有医院签发《居民死亡医学证明（推断）书》；医院以外属正常死亡的，由社区医疗机构签发《居民死亡医学证明（推断）书》；未经救治非正常死亡的，由公安司法部门签发《居民死亡医学证明（推断）书》。
          2.2 网上预约或电话通知殡仪馆接运遗体；<br/>
          2.3 遗体运回殡仪馆防腐。一般情况下遗体应在72小时火化。腐变遗体、甲类传染病、炭疽死亡和国家规定的其他传染病死亡遗体，不进行防腐保存，须立即火化处理。<br/>
          2.4 备齐办丧证件到殡仪馆办理殡殓手续及出殡；证件包括：《居民死亡医学证明（推断）书》原件，已办理死亡注销后的死者户口簿或身份证原件；家属（委托人）身份证原件；属非正常原因死亡的还需提交公安部门和交通管理部门出具的《尸体处理通知书》。<br/>
          2.5 举行告别仪式及遗体火化；<br/>
          2.6 领取骨灰和《遗体火化证》；<br/>
          3、如有问题请拨打殡仪馆公布的联系电话咨询。<br/>
        </div>
        <!--火化寄存-->
        <div v-if="yyType=='emplace'" style="font-size: 14px;margin-left: 40px;margin-right: 35px;">
          1、预约规则<br/>
          1.1在本平台，用户可以对青海省殡葬单位的骨灰寄存业务进行预约。<br/>
          1.2 用户输入预约单位、预约时间、逝者名称、火化时间、火化地点等逝者信息，并输入预约人的姓名、电话、证件类型和证件号等预约人信息进行预约。<br/>
          2、现场办理<br/>
          2.1 用户在办理时间当天到达现场后，出示手机上的预约凭证进行办理。如果由于网络信号或者其他问题，用户无法出示预约凭证，同样可以出示预约人身份证件办理业务。<br/>
          2.2 请用户按照系统中预约的办理时间准时到达现场进行业务办理，逾期自动作废，如仍需寄存需要重新进行预约。<br/>
          2.3 现场办理时需要带上《火化证》、《死亡证》、骨灰、经办人《身份证》。<br/>
          3.4 建议市民选购骨灰容器时尽量不要超过以下规格： 长34cm，高22cm，深25cm。<br/>
          3、如有问题请拨打相关殡葬单位公布的联系电话咨询。<br/>
        </div>
        <!--墓位预约-->
        <div v-if="yyType=='ceme'" style="font-size: 14px;margin-left: 40px;margin-right: 35px;">
          1、预约规则<br/>
          1.1 在本平台，用户可以对青海省殡葬单位的墓位预定业务进行预约。<br/>
          1.2 用户输入预约单位、预约时间、预定墓位、逝者名称、火化时间、火化地点等逝者信息，并输入预约人的姓名、电话、证件类型和证件号等预约人信息进行预约。<br/>
          2、现场办理<br/>
          2.1 用户在办理时间当天到达现场后，出示手机上的预约凭证进行办理。如果由于网络信号或者其他问题，用户无法出示预约凭证，同样可以出示预约人身份证件办理业务。<br/>
          2.2 请用户按照系统中预约的办理时间准时到达现场进行业务办理。<br/>
          3、如有问题请拨打相关殡葬单位公布的联系电话咨询。<br/>

        </div>
        <div style="margin-top: 30px;margin-left: 420px">
          <el-button type="primary" @click="clauseClose" >我已详细阅读</el-button>
        </div>
      </el-dialog>

    </div>
    <div class="clear"></div>
    <footers></footers>

  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";
  import imgUploaderOne from "../../components/ImgUploaderOne";
  export default {
    name: "suggests",
    components:{
      headers,fixedDiv,footers,imgUploaderOne
    },

    data() {
      let _self=this;
      return {
        pickerOptions: {
          disabledDate(v) {
            return v.getTime() < new Date().getTime() ;
          }
        },
        pickerOptions2: {
          disabledDate(v) {
            return v.getTime() > new Date().getTime() -(1000*60* 60*24) ;
          }
        },
        clientType:'web',
        disableds:false,
        areaShow:false,

        loginShow:false,
        gotoIndex:false,
        showClause:true,
        loading:false,
        business:{
          id:'',
          car_id:'',
          resource_id:'',
          cremation_place:'',
          cremation_time:'',
          time_id:'',
          address:'',
          id_card:'',
          organ_id:'',
          area_code:'',
          name:'',
          card_type:'1',
          death_date:'',
          req_name:'',
          death_cause:'',
          req_card_type:'1',
          apply_source:'2',
          mobile_phone:'',
          req_id_card:'',
          relation:'',
          apply_id:'',
          organName:'',
          yy_date:'',
        },
        selectedRegion:[],
        timeList:[],


        rules:{
          yy_date:[{required:true ,message:'请选择预约日期',tigger:'blur'}],
          organName:[{required:true ,message:'请选择预约单位',tigger:'blur'}],
          car_id:[{required:true ,message:'请选择车辆信息',tigger:'blur'}],
          time_id:[{required:true ,message:'请选择时间信息',tigger:'blur'}],
          selectedRegion:[{required:true,validator:this.checkDepartId,tigger:'blur'}],
          address:[{required:true ,message:'请输入接运地址',tigger:'blur'}],
          name:[{required:true ,message:'请输入逝者姓名',tigger:'blur'}],
          card_type:[{required:true ,message:'请选择证件类型',tigger:'blur'}],
          id_card:[ {required: true, validator:this.checkUid, trigger: 'change' }],
          death_date:[ {required: true, message:'请选择去世时间', trigger: 'change' }],
          death_cause:[ {required: true, message:'请选择死亡原因', trigger: 'change' }],
          req_name:[ {required: true, message:'请输入家属姓名', trigger: 'change' }],
          req_card_type:[ {required: true, message:'请选择证件类型', trigger: 'change' }],
          req_id_card:[ {required: true, validator:this.checkUid, trigger: 'change' }],
          mobile_phone:[ {required: true, message:'请输入手机号码', trigger: 'change' }],
          relation:[ {required: true, message:'请选择与逝者关系', trigger: 'change' }],
          cremation_time:[ {required: true, message:'请选择火化时间', trigger: 'change' }],
          cremation_place:[ {required: true, message:'请输入火化地点', trigger: 'change' }],
          resource_id:[ {required: true, message:'请选择位置', trigger: 'change' }],
        },

        props: {
          lazy: true,
          checkStrictly:false,
          lazyLoad (node, resolve) { const { level } = node;
            var t=0;
            if(!node.value){
              node.value=_self.$cookies.get("areaRoot");
              t=1;
              //上级为空，默认设置大通县数据
            }
            const options={pid:node.value}
            _self.$https.post("api/pu/getAreaByParentCode.do",options,response=>{
              const nodes =[];
              // if(t==0) {
              if (response.status === 200 && response.data.code === 200) {
                const nodes = Object.values(response.data.data).map(function (e) {
                  return {label: e.name, value: e.code, level: 0, leaf: level >= 3}
                })
                resolve(nodes);
              } else {
                resolve(nodes);
              }
              // }else{
              //   const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 2}];
              //   resolve(nodes);
              // }
            })
          }
        },
        resources :{
          lazy: true,
          checkStrictly:false,
          lazyLoad (node, resolve) { const { level } = node;
            var t=0;
            if(!node.value){
              node.value=0;
            }else {

            }
            const nodes =[{label:'test',value:'6301210001',level:0, leaf: level >= 2}];
            resolve(nodes);
            const options={organId:this.itemDataYy.organId,parentResource:node.value}
            _self.$https.post("api/ywt/apply/emplacingInfo.do",options,response=>{
              const nodes =[];
              // if(t==0) {
              if (response.status === 200 && response.data.code === 200) {
                const nodes = Object.values(response.data.data).map(function (e) {
                  if (e.isLeaf=='1'){
                    return {label: e.areaName, value: e.areaCode, level: e.parentCode}
                  }else {
                    return {label: e.areaName, value: e.areaCode, level: e.parentCode,children:[]}
                  }
                })
                resolve(nodes);
              } else {
                resolve(nodes);
              }
              // }else{
              //   const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 2}];
              //   resolve(nodes);
              // }
            })
          }
        },
        carList:[
          {
            carId:'1',
            carName:'test',
            timeList:[
              {timeId:'1', startTime:'10:00-12.00'},
               {timeId:'2', startTime:'12:00-14.00'},
            ],
          },{
            carId:'2',
            carName:'test2',
          }],
        gwOptions:[
          {
            id:'2',
            name:'test2',
          }
        ],
        dictArr:{},
        title:'',
        val:'',
        url:'',
        yyType:'',
        checkCity:'',
        itemDataYy:null,
        checkCity2:'',
      }
    } ,

    watch: {
      width(n, o) {
        alert(n + 'w')
      },
      height(n, o) {
        alert(n + 'h')
      },
       val(n, o) {
        let item=this.carList[n-1];
        this.business.car_id=item.carId;
        this.business.time_id='';
        this.timeList=item.timeList;
      },


    },
    created(){
      var userId=this.$cookies.get('userId')
      if (userId==null){
        this.showClause=false;
      }
      this.itemDataYy=this.$route.query.data;
      this.title=this.$route.query.title;
      this.yyType=this.$route.query.yyType;
      this.getDict();
      this.business.organName=this.$route.query.data.organName;
      this.business.organ_id=this.$route.query.data.organId;

      var userId=this.$cookies.get('userId')
      if (userId==null){
        this.showClause=false;
      }



    },
    mounted() {
      //获取applyId;
      var userInfo=this.$cookies.get('userInfo')
      if(!userInfo || userInfo.userId =='' || userInfo.userId ==-1){
        this.loginShow=true;
        this.gotoIndex=true;
        return;
      }
      //报丧
      if (this.yyType=='funeral'){
        this.url='receiveSave'
      }
      //火化寄存
      if (this.yyType=='emplace'){
        this.url='emplaceReceiveSave'
      }
      //墓位预约
      if (this.yyType=='ceme'){
        this.url='cemeReceiveSave'
      }

    },
    methods: {

      onSelectedRegion(v){
        if(this.selectedRegion && this.selectedRegion.length>0){
          this.business.area_code=this.selectedRegion[this.selectedRegion.length-1];
        }else{
          this.business.area_code="";
        }

      },
      reloadPage(){
        this.reload();
      },
      getPartyId(a){

      },
      checkUid(rule,value,callback){
        callback(this.$util.func.uid.check(value))
      },



      submit(){
        this.$refs['ruleForm'].validate((valid) => {

          if (valid) {

            var loading = this.$loading({
              lock: true,
              text: '数据提交中,请耐心等待....',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            const options={
              data:this.business
            }
            this.$https.post("api/funeral/"+this.url+".do",options,response=>{
              if (response.status === 200 && response.data.code === 200) {
                loading.close();
                this.$alert('提交成功！', {
                  confirmButtonText: '确定'}).then(() => {
                  this.$router.push('personal_cardMaking');
                });
              }else {
                loading.close();
                this.$alert(response.data.message, {
                  confirmButtonText: '确定'});
              }
            })
          }else {

            return
          }
        })
      },
      getDict(){
        var t=this;
        this.$https.post("api/funeral/getDictAll.do",{},response=>{
          if (response.status === 200 && response.data.code===200) {
            t.dictArr=response.data.data;
          }
        })
      },
      handleDialogClose(){
        this.urlTo('organinfoList',{yyType:this.yyType,title:this.title})
      },
      clauseClose(){
        this.showClause=false;
      },
      checkDepartId(rule,value,callback){
        if(!this.selectedRegion || this.selectedRegion.length<=0){
          return callback(new Error('请选择区划'))
        }
        return  callback()
      },

      urlTo(url, params) {
        this.$router.push({path: url, query: params || {}});
      },



    }
  }



</script>
<style>

</style>



// WEBPACK FOOTER //
// src/pages/personal/OrganinfoListSubmit.vue